// `color` mirrors each `className` background as a hex value, for contexts (e.g. emails)
// that can't rely on the app's stylesheet and need the color inlined instead.
export const FILE_TYPE_BADGES: Record<string, { label: string; className: string; color: string }> = {
  pdf: { label: 'PDF', className: 'bg-red-100', color: '#e40741' },
  doc: { label: 'DOC', className: 'bg-light-blue', color: '#0094cc' },
  docx: { label: 'DOC', className: 'bg-light-blue', color: '#0094cc' },
  xls: { label: 'XLS', className: 'bg-green', color: '#08aa7b' },
  xlsx: { label: 'XLS', className: 'bg-green', color: '#08aa7b' },
  csv: { label: 'CSV', className: 'bg-green', color: '#08aa7b' },
  ppt: { label: 'PPT', className: 'bg-yellow', color: '#f2a805' },
  pptx: { label: 'PPT', className: 'bg-yellow', color: '#f2a805' },
};

export const getFileBadge = (fileName = '') => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  return (
    FILE_TYPE_BADGES[ext] ?? {
      label: ext ? ext.slice(0, 3).toUpperCase() : 'FILE',
      className: 'bg-main-blue',
      color: '#00122b',
    }
  );
};
